import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import IssuanceUniversityCardRegisterView from './IssuanceUniversityCardRegisterView';
import { Creators as procedureActions } from '../../../../../../../domain/useCases/procedures/getProcedureInformation';
import { Creators as registerActions } from '../../../../../../../domain/useCases/procedures/registerCarnetUseCase';
import { Creators as requestStatusActions } from '../../../../../../../domain/useCases/procedures/getStudentProcedureStatus';
import { Creators as modalityActions } from '../../../../../../../domain/useCases/procedures/getCampusByModality';
import constants from '../../../../constants';
import routes from '../../../../../../components/Routes/routingMap';
import useFields from './hooks/useFields';

const IssuanceUniversityCardRegisterViewController = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { fields, errors, setFieldValue, setFieldError } = useFields();

  const profile = useSelector((state: any) => state.profile?.data?.academic);
  const { phone, direction, detail, deliveryMode, districtId } = fields;
  const { phone: errorPhone } = errors;

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectCampus, setSelectCampus] = useState('');
  const [campusSelectedName, setCampusSelectedName] = useState('');

  const handleCloseConfirmationModal = () => {
    setShowConfirmationModal(false);
  };

  const handlerSelectCampus = (campusSelected: string) => {
    setSelectCampus(campusSelected);
  };

  const validateField = ({ name, value }: any) => {
    const validator: { [key: string]: boolean } = {
      phone: value.length > 9
    };
    setFieldError({ name, value: validator[name] });
    setFieldValue({ name, value });
  };

  const procedure = useSelector(
    (state: any) => state.procedureInformation?.procedure
  );

  const { isLoading, requestId, isSuccess } = useSelector(
    (state: any) => state.registerCarnet
  );

  const getCampusList = useSelector(
    (state: any) => state.getCampusByModality?.data
  );

  const formatCampusList = (campus: any) => {
    let campusName = campus?.name?.replace('UTP', '');
    campusName = campusName.replace('CAMPUS', '').toLowerCase();
    campusName = campusName.substring(1);
    campusName = campusName
      .split(' ')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
    return { id: campus?.id, name: campusName };
  };
  const campusList = getCampusList?.map(formatCampusList);

  const resultFormPrint = () => {
    if (procedure?.isProvince && deliveryMode === 'R') {
      return 'P';
    }
    if (!procedure?.isProvince && deliveryMode === 'R') {
      return 'B';
    }
    if (!procedure?.isProvince && deliveryMode === '') {
      return 'C';
    }

    return 'A';
  };

  useEffect(() => {
    if (!procedure?.isProvince) {
      setFieldValue({
        name: 'deliveryMode',
        value: ''
      });
    }

    if (!procedure) {
      dispatch(
        procedureActions.getProcedureInformation(
          constants.categories.requests.procedures.issuanceUniversityCard
        )
      );
    }

    dispatch(modalityActions.getCampusByModality('PPE'));
  }, []);

  useEffect(() => {
    resultFormPrint();
  }, [deliveryMode]);

  const registerIssuance = () => {
    const request = {
      period: '',
      campus: selectCampus, // profile?.campus,
      phone: fields.phone,
      districtId: fields.districtId === '' ? null : fields.districtId,
      address: fields.direction,
      reference: fields.detail,
      deliveryMode: fields.deliveryMode
    };
    dispatch(registerActions.registerCarnet(request));
  };

  useEffect(() => {
    if (requestId && isSuccess) {
      dispatch(
        requestStatusActions.getStudentProcedureStatus(
          constants.categories.requests.procedures.issuanceUniversityCard,
          requestId
        )
      );
      history.push(
        routes.student.procedures.categories.requests.issuancefuniversitycard
          .procedureprogress
      );
    }
  }, [requestId, isSuccess]);

  useEffect(() => {
    if (profile?.campus !== 'VIRT') {
      setFieldValue({
        name: 'deliveryMode',
        value: 'R'
      });

      handlerSelectCampus(profile?.campus);
    }
  }, []);

  useEffect(() => {
    if (selectCampus) {
      setFieldValue({
        name: 'deliveryMode',
        value: 'R'
      });
    }
  }, [selectCampus]);

  useEffect(() => {
    if (selectCampus !== '' && campusList) {
      setCampusSelectedName(
        campusList[campusList.findIndex((c: any) => c?.id === selectCampus)]
          .name
      );
    }
  }, [campusList]);

  return (
    <IssuanceUniversityCardRegisterView
      procedure={procedure}
      profile={profile}
      isLoading={isLoading}
      phone={phone}
      direction={direction}
      detail={detail}
      deliveryMode={deliveryMode}
      districtId={districtId}
      validateField={validateField}
      errorPhone={errorPhone}
      registerIssuance={registerIssuance}
      resultFormPrint={resultFormPrint}
      showConfirmationModal={showConfirmationModal}
      handleCloseConfirmationModal={handleCloseConfirmationModal}
      setShowConfirmationModal={setShowConfirmationModal}
      campusList={campusList}
      selectCampus={selectCampus}
      campusName={campusSelectedName}
      handlerSelectCampus={handlerSelectCampus}
    />
  );
};

export default IssuanceUniversityCardRegisterViewController;
